import { useEffect, useState } from "react";
import axios from 'axios';
import Loading from '../../../component/common/loading/Loading.jsx';
import ExcelDownload from "../../../component/common/button/ExcelDownload.jsx";
import PopupDataGrid from "../../../component/common/popup/PopupDataGrid.jsx";

const CallArrival_popup = () => {
    const [data, setData] = useState([{}]);

    const head = ['기관명', '의무기록번호', '내원일시', '외상팀 호출일시', '외상팀 도착일시', '활성화팀 호출여부', 'on-call 호출여부']; //component화 
    const head_column = ['TRMSEMNM', 'TRMSIDNO', 'TRMSINDTM', 'CLTPCLDTM', 'CLTPTEDTM', 'TRMSCLYN', 'TRMSONYN'];
    const excelhead = ['기관명', '의무기록번호', '내원일시', '외상팀 호출일시', '외상팀 도착일시', '활성화팀 호출여부', 'on-call 호출여부'];
    const excelhead_column = ['TRMSEMNM', 'TRMSIDNO', 'TRMSINDTM', 'CLTPCLDTM', 'CLTPTEDTM', 'TRMSCLYN', 'TRMSONYN'];

    const isSearched = true;

    const sendData = JSON.parse(localStorage.getItem('callArrivalData'));

    const [loading, setLoading] = useState(false);

    const popupData = async () => {
        try {
            const response = await axios.get('/trmsapi/trtinfo/bdtongtrms_stat_to_call_arrival_use_time_popup_data.do',
                { params: sendData }
            );
            setData(response.data);
            setLoading(false);
        } catch (e) {
            console.error('body 내용 로딩 중 오류 발생', e);
        }
    }

    useEffect(() => {
        setLoading(true);
        popupData();
    }, []);

    const flag = sendData.flag;

    return (
        <div className={`popup_container ${flag === 'ptmi' ? 'bg_st_bg' : flag === 'trms' ? 'bg_tr_bg' : ''}`}>
            <div className='flex justify-between'>
                <h5 className='sub_title w-70'>데이터 목록 - 환자정보</h5>
                {data.length === 0 ? '' :
                    <div className='btn_container mt-3'>
                        <ExcelDownload excelHead={excelhead} searched={isSearched} excelData={data} dataCode={excelhead_column} excelFileName={'충실도 월별 전송 내역_상세 데이터'} />
                    </div>
                }
            </div>
            {loading ? <Loading /> :
                <PopupDataGrid
                    dataHead={head}
                    dataColumn={head_column}
                    dataList={data}
                    flag={flag} />
            }
        </div>
    )
}

export default CallArrival_popup;